/* eslint-disable no-unused-vars */
export default {
  mounted(el, binding) {
    // Store the original value to prevent cursor jumping
    let previousValue = '';

    const formatWithSlashes = (value) => {
      // Remove all non-digit characters
      let cleaned = value.replace(/\D/g, '');

      // Format as dd/mm/yyyy
      if (cleaned.length >= 2) {
        cleaned = cleaned.slice(0, 2) + '/' + cleaned.slice(2);
      }
      if (cleaned.length >= 5) {
        cleaned = cleaned.slice(0, 5) + '/' + cleaned.slice(5);
      }

      // Limit to 10 characters (dd/mm/yyyy)
      return cleaned.slice(0, 10);
    };

    const handleInput = (event) => {
      const input = event.target;
      let value = input.value;

      // Get cursor position
      const cursorPos = input.selectionStart || 0;

      // Check if user is deleting (backspace or delete)
      const isDeleting = event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward';

      // Format the value with slashes
      const formatted = formatWithSlashes(value);

      // Only update if value changed
      if (formatted !== value) {
        // Store current cursor position relative to raw digits
        const rawDigits = value.replace(/\D/g, '');
        const digitIndex = rawDigits.length - 1;

        // Update the input value
        input.value = formatted;

        // Calculate new cursor position
        let newCursorPos = cursorPos;
        if (isDeleting) {
          // When deleting, keep cursor at current position
          newCursorPos = cursorPos;
        } else {
          // When typing, move cursor forward, but skip over slashes
          const formattedBeforeCursor = formatted.slice(0, cursorPos);
          const rawBeforeCursor = formattedBeforeCursor.replace(/\D/g, '');
          const typedDigits = rawDigits.length;

          if (typedDigits <= 2) {
            newCursorPos = typedDigits;
          } else if (typedDigits <= 4) {
            newCursorPos = typedDigits + 1; // +1 for the slash
          } else {
            newCursorPos = typedDigits + 2; // +2 for both slashes
          }
          newCursorPos = Math.min(newCursorPos, formatted.length);
        }

        // Set cursor position
        requestAnimationFrame(() => {
          input.setSelectionRange(newCursorPos, newCursorPos);
        });

        // Trigger the input event to update v-model
        const updateEvent = new Event('input', { bubbles: true });
        input.dispatchEvent(updateEvent);
      }

      previousValue = formatted;
    };

    // Add input event listener
    el.addEventListener('input', handleInput);

    // Clean up event listener on component destroy
    el._cleanup = () => {
      el.removeEventListener('input', handleInput);
    };
  },

  unmounted(el) {
    // Clean up event listener
    if (el._cleanup) {
      el._cleanup();
    }
  }
};
